import { Component, OnInit, ChangeDetectionStrategy, Input, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { ViewService } from '../../view.service';
import { Select, Store } from '@ngxs/store';
import { StoryChaptersState } from 'src/app/story/state/chapters/story.chapters.state';
import { Observable, Subject } from 'rxjs';
import { ChapterModel } from 'src/app/story/models/chapter.model';
import { StoryLabelsState } from 'src/app/story/state/labels/story.labels.state';
import { LabelModel } from 'src/app/story/models/labels/label.model';
import { ViewUIService } from '../../view-ui.service';
import { ViewUI } from '../../models/view-ui.enum';
import { ViewState } from '../../state/view.state';
import { takeUntil } from 'rxjs/operators';
import { ContentBlock } from 'src/app/content-blocks/models/content-block';
import { ContentBlockTypes } from 'src/app/content-blocks/models/content-block-types';
import { ViewLayout } from '../../models/view-layout';

@Component({
  selector: 'app-view-content-mode',
  templateUrl: './view-content-mode.component.html',
  styleUrls: ['./view-content-mode.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ViewContentModeComponent implements OnInit, OnDestroy {
  // ---------- Observables ----------
  @Select(StoryChaptersState.getStoryChapters)
  chapters$: Observable<ChapterModel[]>;

  @Select(StoryChaptersState.getSelectedChapter)
  chapter$: Observable<ChapterModel>;

  @Select(StoryChaptersState.getSelectedChapterContentBlocks)
  contentBlocks$: Observable<ContentBlock>;

  @Select(StoryLabelsState.getChapterLabels)
  labels$: Observable<LabelModel[]>;

  private ngUnsubscribe = new Subject();
  
  
  // ---------- Input / Output ----------
  @Input()
  layout: ViewLayout = ViewLayout.Column;

  
  
  
  // ---------- Class Variables ----------
  viewLayout = ViewUI;
  isPopulated = true;
  descriptionVisible = false;
  legendVisible = false;
  labelListVisible = false;
  contentBlockTypes = ContentBlockTypes;


  // ---------- Lifecyle Events ----------
  constructor(
    private store: Store,
    private viewService: ViewService,
    private layoutService: ViewUIService,
    private changeDetectorRef: ChangeDetectorRef
  ) { }

  ngOnInit() {
    this.store
      .select(ViewState.getUI)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(() => {
        this.descriptionVisible = this.isVisible(ViewUI.Description);
        this.legendVisible = this.isVisible(ViewUI.Legend);
        this.labelListVisible = this.isVisible(ViewUI.LabelList);

        this.changeDetectorRef.markForCheck();
      });
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }


  // ---------- Layout ----------
  isVisible(layout: ViewUI) {
    return this.layoutService.isUIVisible(layout);
  }

  isEnabled(layout: ViewUI) {
    return this.layoutService.isUIEnabled(layout);
  }
  
  
  // ---------- Interaction ----------
  handlePrevClick() {
    this.selectLabel(-1);
  }

  handleNextClick() {
    this.selectLabel(1);
  }

  selectLabel(increment: number) {
    const labels = this.store.selectSnapshot(StoryLabelsState.getChapterLabels);
    const labelCount = labels.length;
    const selectedLabelId = this.store.selectSnapshot(StoryLabelsState.getSelectedLabelId);
    const selectedLabelIndex = labels.findIndex((label) => label.id === selectedLabelId);
    
    // get next index
    const nextIndex = selectedLabelIndex !== -1
      // increment
      ? selectedLabelIndex + increment
      // defafult
      : 0;

    // cycle target index in range
    const targetLabelIndex = (nextIndex % labelCount + labelCount) % labelCount;

    // get target label
    const targetLabel = labels[targetLabelIndex];
    if (targetLabel) {
      this.viewService.selectLabel(targetLabel, true);
    }
  }

}
